// Enums e Função de Consultor
enum MechanicGoiania {
  ARLISSON_ALVES_LIRA = "Arlisson Alves Lira",
  GUSTAVO_ANDRE_DOS_SANTOS_PAULA = "Gustavo Andre Dos Santos Paula",
  WESLEY_JUNIOR_DO_NASCIMENTO_DIAS = "Wesley Junior Do Nascimento Dias",
  LUCAS_DOS_SANTOS_ROCHA = "Lucas Dos Santos Rocha",
  ATILAS_MAIA_LEMOS = "Atilas Maia Lemos",
  LUCIANO_COSTA = "Luciano Costa Dos Santos",
  MATHEUS_ROGER = "Matheus Roger Medeiros Evangelista",
  GABRYEL_FERNANDES_NOLETO_TORRES = "Gabryel Fernandes Noleto Torres",
  ULISSES_MARCADO = "Ulisses Marcado",
  KAWA_FELIPE = "Kawa Felipe",
  ADRIANO_LIMA_DE_FREITAS = "Adriano Lima de Freitas",
  RODRIGO_DA_CONCEICAO = "Rodrigo da Conceição",
  CLEVSERSON_RODRIGUES_DE_SOUZA = "Cleverson Rodrigues de Souza",
  LUCAS_DAS_NEVES_DE_SANTANA = "Lucas das Neves de Santana",
  LEVI_AZEVEDO_ALVES = "Levi Azevedo Alves"
}

enum MechanicBrasilia {
  JOAO_PAULO_GOMES_DE_OLIVEIRA_SANTANA = "João Paulo Gomes de Oliveira Santana",
  HEBERTH_MENDES_RAMOS = "Heberth Mendes Ramos",
  GABRIEL_MACEDO_PINO = "Gabriel Macedo Pino"
}

enum MechanicCampoGrande {
  PHILIPI_MORENO = "Phillipe Moreno Oliveira Novais",
  CARLOS_WILLIAN = "Carlos Willian Rodrigues Mariano",
  ERIVELTON_MOURA = "Erivelton Moura Da Silva",
  MARCELO_SANTOS = "Marcelo dos Santos",
  JOAO_BENITES = "João Benites"
}

enum MechanicAnapolis {
  THIAGO_RODOLFO_FERNANDES_BARROS = "Thiago Rodolfo Fernandes Barros",
}

enum MechanicRioVerde {
  VITOR_BARROS_DE_OLIVEIRA = "Vitor Barros de Oliveira",
  ANDREY_JUNIOR_DOS_SANTOS = "Andrey Júnior dos Santos"
}

enum MechanicTeresina {
  ANDERSON_COSTA = "Anderson da Silva Costa",
  JOSÉ_BARBOSA_DA_SILVA_JUNIOR = "José Barbosa da Silva Junior",
  PABLO_JOSÉ_BARBOSA_LEAL = "Pablo José Barbosa Leal",
  ANTÔNIO_BASTOS_OLIVEIRA = "Antônio Bastos Oliveira",
  MARCOS_FRANK_SANTOS = "Marcos Frank Santos",
  EDUARDO_DOS_SANTOS_SOARES = "Eduardo dos Santos Soares"
}

enum MechanicCuiaba {
  LUIZ_FERNANDO = "Luiz Fernando Pereira de Souza",
  PEDRO_THAIGO = "Pedro Thaigo Antonny",
  LEVI_NAZARENO_SOUZA_DOS_SANTOS = "Levi Nazareno Souza Dos Santos",
  GABRIEL_FREITAS = "Gabriel Freitas",
  DAVI_NUNES = "Davi Nunes",
  JOAO_MARCOS = "João Marcos",
  RAPHAEL_MAX = "Raphael Max",
  DAVI_SANTANA_SOARES = "Davi Santana Soares"
}

enum MechanicRecife {
  RICARDO_CAVALCANTE_DA_PAZ = "Ricardo Cavalcante da Paz",
}

// Defina o tipo para as opções de consultores
interface MechanicOption {
  value: string;
  label: string;
}

export const getMechanicOptions = (companyName: string, savedValue?: string): MechanicOption[] => {
  const baseOptions: MechanicOption[] = [
    { value: "", label: "-" },  // Adiciona a opção vazia no início
  ];

  let specificOptions: MechanicOption[] = [];

  switch (companyName) {
    case "BRASILIA/DF":
      specificOptions = Object.values(MechanicBrasilia).map(value => ({
        value,
        label: value,
      }));
      break;
    case "GOIANIA/GO":
      specificOptions = Object.values(MechanicGoiania).map(value => ({
        value,
        label: value,
      }));
      break;
    case "CAMPO GRANDE/MS":
      specificOptions = Object.values(MechanicCampoGrande).map(value => ({
        value,
        label: value,
      }));
      break;
    case "RIO VERDE/GO":
      specificOptions = Object.values(MechanicRioVerde).map(value => ({
        value,
        label: value,
      }));
      break;
    case "ANAPOLIS/GO":
      specificOptions = Object.values(MechanicAnapolis).map(value => ({
        value,
        label: value,
      }));
      break;
    case "CUIABA/MT":
      specificOptions = Object.values(MechanicCuiaba).map(value => ({
        value,
        label: value,
      }));
      break;
    case "TERESINA/PI":
      specificOptions = Object.values(MechanicTeresina).map(value => ({
        value,
        label: value,
      }));
      break;
    case "RECIFE/PE":
      specificOptions = Object.values(MechanicRecife).map(value => ({
        value,
        label: value,
      }));
      break;
    // case "APARECIDA DE GOIANIA/GO":
    //   specificOptions = Object.values(MechanicAparecida).map(value => ({
    //     value,
    //     label: value,
    //   }));
    //   break;
    default:
      specificOptions = [];
      break;
  }

  // Adiciona o valor salvo às opções, caso não esteja presente nas opções específicas
  if (savedValue && !specificOptions.some(option => option.value === savedValue)) {
    specificOptions.unshift({ value: savedValue, label: savedValue });
  }

  return [...baseOptions, ...specificOptions]; // Combina a opção vazia com as específicas e a opção salva
}
